// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Agenda_AlterarStatusCompromissoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /agenda/alterar_status_compromisso
 *
 * Returns success flag indicating whether the status was updated.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Agenda_AlterarStatusCompromissoResponseDados = boolean;

export type Agenda_AlterarStatusCompromissoResponse = ApiResponse<Agenda_AlterarStatusCompromissoResponseDados>;

registerResponseContract('Agenda_AlterarStatusCompromissoResponse', {})
